import React, { useMemo } from 'react';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import HomeIcon from '../../assets/icons/home-sweet-home.svg?react';
import styles from './Breadcrumbs.module.scss';
import { Link } from 'react-router-dom';
import clsx from 'clsx';

type OwnProps = {
  pageName?: string;
  children?: React.ReactNode;
  customLinkForHomeIcon?: string;
};
export const Breadcrumbs = (props: OwnProps) => {
  const location = useLocation();
  const i18n = useTranslation();

  const linksArray = useMemo(() => {
    const result: {
      to: string;
      name: string;
    }[] = [];

    const pathParts = location.pathname.split('/');

    let to = '';

    for (const part of pathParts) {
      if (!part) continue;

      to += `/${part}`;
      if (!isNaN(+part)) {
        result.push({
          name: part,
          to,
        });
      } else {
        const key = `breadcrumbs./${part}`;
        const name = i18n.t(key, { defaultValue: '' });

        result.push({ name, to });
      }
    }

    return result;
  }, [location.pathname, i18n]);

  return (
    <div className={clsx(styles.rowContainer, styles.wrapper)}>
      <div className={clsx(styles.rowContainer, styles.columnGap_8)}>
        <Link
          to={props.customLinkForHomeIcon ?? '/'}
          data-test-id={'home-link'}
        >
          <HomeIcon className={styles.hoverStyles} />
        </Link>
        {linksArray.map((link, index) => {
          const isNameTypeOfNumber = Boolean(!isNaN(+link.name));

          if (
            (isNameTypeOfNumber &&
              index + 1 === linksArray.length &&
              !props.pageName) ||
            (!link.name && index + 1 !== linksArray.length)
          )
            return null;

          return (
            <div
              key={link.to}
              className={clsx(styles.rowContainer, styles.columnGap_8)}
            >
              {(link.name || props.pageName) && (
                <div style={{ cursor: 'default' }} className={styles.pathPart}>
                  /
                </div>
              )}
              {index === linksArray.length - 1 ? (
                <div
                  data-test-id={'last-breadcrumb'}
                  className={clsx(styles.pathPart, styles.pathEnd)}
                >
                  {props.pageName ?? link.name}
                </div>
              ) : (
                <Link
                  to={link.to}
                  className={clsx(styles.pathPart, styles.hoverStyles)}
                >
                  {link.name}
                </Link>
              )}
            </div>
          );
        })}
      </div>
      {props.children}
    </div>
  );
};
